export default {
    acquiring_device: "Ödəniş qəbul edən cihaz",
    add_expense: "Xərc əlavə edin",
    add_income: "Gəlir əlavə edin",
    advance_noun: "Öncədən ödəniş",
    all_pay_methods: "Bütün ödəniş metodları",
    bank_terminal: "Bank terminalı",
    cash_operation: "Kassa əməliyyatı",
    cashdesk: "Kassa",
    cashier: "Kassir",
    cashier_inn: "Kassirin VÖEN-i",
    cashier_name: "Kassirin adı",
    cashless_payment: "Nağdsız ödəniş",
    cashless_payments: "Nağdsız ödənişlər",
    cheque: "Çek",
    cheque_generation_in_process_status_might_change_later: "Çek yaradılır. Statusun dəyişməsi bir qədər vaxt apara bilər.",
    cheques: "Çeklər",
    close_shift: "Növbəni bağla",
    closing_balance: "Günün sonuna qalıq",
    create_cheque: "Fiskal çek yarad",
    dashboard: "Tablosuna",
    data_is_invalid: "Məlumat etibarsızdır",
    data_is_valid: "Məlumat etibarlıdır",
    deposit_to_cashdesk: "Kassaya pul qoymaq",
    enter_amount: "Məbləği daxil etmək",
    enter_the_cheque_number: "Çekin nömrəsini daxil edin",
    error_printing_cheque: "Çekin çapında xəta",
    fiscal_cheque_copy_print: "Maliyyə Check surətini çap edin",
    fiscal_cheque_print: "Maliyyə yoxlama çapı",
    fiscal_device: "Fiskal cihaz",
    fiscal_registrar: "Maliyyə qeydiyyatı",
    fiscal_registrar_management: "Maliyyə Qeydiyyatı İdarəetmə",
    fixed: "Sabit",
    injection: "Pulun artırılması",
    issue_an_advance: "Avans vermək",
    kkm_url: "Ticarət avadanlığı serverinin HTTP ünvanı. Kassa serveri yerli olaraq qoşulmamışdırsa doldurun.",
    market_as_fiscal_cheque_manually: "Fiskal çek kimi əl ilə işarələyin",
    name_of_service_in_cheque: "Çekdə xidmətin adı",
    not_subject_to_vat: "ƏDV-yə cəlb olunmur",
    only_for_payment_through_terminal: "Yalnız terminal vasitəsilə ödəniş üçün",
    open_shift: "Növbəni aç",
    opened_at: "Açılış tarixi",
    opening_balance: "Günün əvvəlinə qalıq",
    partial_prepayment: "Qismən öncədən ödəniş",
    print_totals: "Toplamı çap et",
    process_advances_as: "Öncədən ödənişləri aşağıdakılar kimi işləyin",
    sale_of_goods: "Malların satışı",
    sales: "Satışlar",
    send_services_in_cheque: "Xidməti çekə daxil et",
    shift: "Növbə",
    shift_number: "Növbənin nömrəsi",
    shifts: "Növbələr",
    system_to_use: "İstifadə olunacaq sistem",
    terminal: "Terminal",
    totals: "Cəm",
    vat_rate: "ƏDV dərəcəsi",
    waiting_for_payment_in_terminal: "Terminalla ödəniş gözlənilir",
    who_accepts_payment: "Ödənişi kim",
    withdraw_from_cashdesk: "Kassadan çıxarış",
    withdrawal: "Çıxarış",
    withdrawal_replenishment_from_the_cash_register: "Kassa reyestrindən geri çəkilmə",
    withdrawal_replenishment_of_cash: "Pulun çəkilməsi / doldurulması",
    xreport: "X-hesabat",
    xreports: "X-hesabatlar"
}
